import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class CertificatesStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
